import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function LimitedEditions() {
  return <section id="limited" className="py-24 bg-[#0F0F0F] border-y border-[#F5F5F0]/5" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-115">
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#C9A962] z-10" data-id="element-116"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#C9A962] z-10" data-id="element-117"></div>

            <div className="relative aspect-square overflow-hidden bg-[#0A0A0A]" data-id="element-118">
              <img src="https://images.unsplash.com/photo-1605901309584-818e25960b8f?w=1000&q=80" alt="Nyx Shadowblade Replica" className="w-full h-full object-cover opacity-90 hover:opacity-100 transition-opacity duration-500" data-id="element-119" />

              <div className="absolute top-6 right-6 bg-[#0A0A0A]/90 backdrop-blur border border-[#C9A962]/30 px-4 py-2" data-id="element-120">
                <p className="text-[#C9A962] font-mono font-bold" data-id="element-121">047 / 250</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="space-y-8" data-id="element-122">
            <div data-id="element-123">
              <div className="flex items-center space-x-2 mb-4" data-id="element-124">
                <Star className="text-[#C9A962] fill-[#C9A962]" size={16} data-id="element-125" />
                <span className="text-[#C9A962] font-mono text-sm tracking-widest uppercase" data-id="element-126">
                  Featured Rarity
                </span>
              </div>
              <h2 className="text-4xl md:text-5xl font-serif text-[#F5F5F0] mb-4" data-id="element-127">
                Nyx Shadowblade Replica
              </h2>
              <p className="text-xl text-[#F5F5F0]/60 font-light" data-id="element-128">
                Hand-forged steel with obsidian inlay. Fully authenticated 1:1
                scale replica from the Shadowfall Chronicles.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 border-y border-[#F5F5F0]/10 py-8" data-id="element-129">
              <div data-id="element-130">
                <p className="text-[#F5F5F0]/40 text-sm uppercase tracking-wider mb-1" data-id="element-131">
                  Material
                </p>
                <p className="text-[#F5F5F0] font-medium" data-id="element-132">
                  Damascus Steel & Obsidian
                </p>
              </div>
              <div data-id="element-133">
                <p className="text-[#F5F5F0]/40 text-sm uppercase tracking-wider mb-1" data-id="element-134">
                  Dimensions
                </p>
                <p className="text-[#F5F5F0] font-medium" data-id="element-135">115cm Length</p>
              </div>
              <div data-id="element-136">
                <p className="text-[#F5F5F0]/40 text-sm uppercase tracking-wider mb-1" data-id="element-137">
                  Weight
                </p>
                <p className="text-[#F5F5F0] font-medium" data-id="element-138">2.4 kg</p>
              </div>
              <div data-id="element-139">
                <p className="text-[#F5F5F0]/40 text-sm uppercase tracking-wider mb-1" data-id="element-140">
                  Release Date
                </p>
                <p className="text-[#F5F5F0] font-medium" data-id="element-141">Oct 12, 2025</p>
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-142">
              <div data-id="element-143">
                <p className="text-3xl font-serif text-[#F5F5F0]" data-id="element-144">€345.00</p>
                <div className="flex items-center mt-1 text-[#C9A962] text-sm" data-id="element-145">
                  <ShieldCheck size={14} className="mr-1" data-id="element-146" />
                  <span data-id="element-147">Certificate of Authenticity included</span>
                </div>
              </div>
              <Button size="lg" data-id="element-148">Secure This Piece</Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}